import React from 'react'
import ListingDetailContainer from '../../templates/listing-detail/ListingDetailContainer'
import withParams from '../../../modules/router-manage/withParams'
import Navbar from '../../templates/navbar/Navbar'
import TownHeader from '../../templates/navbar/TownHeader'
import ListingHeader from '../../templates/navbar/ListingHeader'

const ListingCreatePage = props => (
  <div>
    <Navbar />
    <div className="container">
      <div className="section">
        <TownHeader />
        <ListingHeader />
        <hr/>
        <ListingDetailContainer {...props} />
      </div>
    </div>
  </div>
)

export default withParams(ListingCreatePage)



// WEBPACK FOOTER //
// ./src/components/pages/web/ListingCreatePage.js